module.exports = __webpack_public_path__ + "static/media/icon34.46fa3ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon34.png
// module id = 743
// module chunks = 0 1